import { UserBoxContainer } from "./styles";

import Spacer, { Axis } from "~/components/Spacer";
import useCurrentViewer from "~/hooks/useCurrentViewer";
import useCurrentViewerVaspDID from "~/hooks/useCurrentViewerVaspDID";
import VASPAnalyticsDashboard from "~/templates/companies/components/VASPAnalyticsDashboard";
import VASPDescription from "~/templates/companies/components/VASPDescription";
import VASPImplementationStatus from "~/templates/companies/components/VASPImplementationStatus";
import VASPLicenseRegistration from "~/templates/companies/components/VASPLicenseRegistration";
import VASPVerifications from "~/templates/companies/components/VASPVerifications";
import { VASP } from "~/types/vaspid";

interface Props {
  vasp: VASP | undefined;
  onClickViewDDQ?: () => void;
  showMetabaseDashboard: boolean;
}

export default function VaspInfoSections({ vasp, onClickViewDDQ, showMetabaseDashboard }: Props) {
  const { viewer: currentViewer } = useCurrentViewer();
  const isLoggedIn = currentViewer.did !== "noUser";
  const currentVASPdid = useCurrentViewerVaspDID();

  const isMyVasp = currentVASPdid === vasp?.did;
  const hasSubsidiaries = (vasp?.subsidiaries?.length ?? 0) > 0;

  return (
    <>
      <UserBoxContainer>
        <Spacer axis={Axis.VERTICAL} size={20} />
        <VASPDescription vasp={vasp} />
        {showMetabaseDashboard && isMyVasp && (
          <>
            <Spacer axis={Axis.VERTICAL} size={20} />
            <VASPAnalyticsDashboard vaspId={currentVASPdid} />
          </>
        )}
        <Spacer axis={Axis.VERTICAL} size={20} />
        <VASPImplementationStatus vasp={vasp} />
        <Spacer axis={Axis.VERTICAL} size={20} />
        <VASPLicenseRegistration vasp={vasp} userIsAuthenticated={isLoggedIn} />
        <Spacer axis={Axis.VERTICAL} size={20} />
        {!hasSubsidiaries && isLoggedIn && vasp && (
          <VASPVerifications vasp={vasp} userIsAuthenticated={isLoggedIn} onClickViewDDQ={onClickViewDDQ} />
        )}
      </UserBoxContainer>
    </>
  );
}
